import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { SuggestResult } from '@xiag-search/sdk';
import { suggestRequestSdk } from 'src/sagas/utils/requestSdk';

export function* suggestFetch(query: string): SagaIterator {
    const data: SuggestResult = yield call(suggestRequestSdk, { query, size: 6 });
    return data.suggests;
}
